import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    Key,
} from '@denishussar/html5-game-engine';
import { AnimationContents } from '../../../../AnimationContents';
import { GamePadJoystickController } from './GamePadJoystickController';
import { GameLogic } from '../../../Logic/GameLogic';
import { GamePadButtonsController } from './GamePadButtonsController';
import { ButtonController } from '../../../Common/ButtonController';
import { GamePadModel } from '../../../Models/Game/GamePadModel';

export interface IGamePadContainerControllerOptions {}

export class GamePadContainerController extends AnimationBaseController {
    $model: GamePadModel;

    public constructor(
        @Inject private _options: IGamePadContainerControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super('GamePadContainerController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'gamepad_container',
            childControllers: {
                Joystick: {
                    instanceName: 'joystick',
                    view: GamePadJoystickController,
                    model: this.$model,
                },
                Buttons: {
                    instanceName: 'buttons',
                    view: GamePadButtonsController,
                    model: this.$model,
                },
                CloseButton: {
                    instanceName: 'button_close',
                    view: ButtonController,
                    model: this.$model,
                },
            },
            modelWatch: {
                visible: (visible: boolean) => {
                    this.visible = visible;
                },
                showGamePad: (showGamePad: boolean) => {
                    this.$childControllers.get('Joystick').visible =
                        showGamePad;
                    this.$childControllers.get('Buttons').visible = showGamePad;
                },
            },
            keyboard: {
                [Key['A']]: {
                    pressed: () => {
                        this._gameLogic.unitMoveStart([-1, 0]);
                    },
                    released: () => {
                        this._gameLogic.unitMoveStop([-1, 0]);
                    },
                    down: () => {},
                },
                [Key['D']]: {
                    pressed: () => {
                        this._gameLogic.unitMoveStart([1, 0]);
                    },
                    released: () => {
                        this._gameLogic.unitMoveStop([1, 0]);
                    },
                    down: () => {},
                },
                [Key['W']]: {
                    pressed: () => {
                        this._gameLogic.unitMoveStart([0, -1]);
                    },
                    released: () => {
                        this._gameLogic.unitMoveStop([0, -1]);
                    },
                    down: () => {},
                },
                [Key['S']]: {
                    pressed: () => {
                        this._gameLogic.unitMoveStart([0, 1]);
                    },
                    released: () => {
                        this._gameLogic.unitMoveStop([0, 1]);
                    },
                    down: () => {},
                },
                [Key['SPACE']]: {
                    pressed: () => {},
                    released: () => {
                        //this._gameLogic.playerShoot(this.$model.playerId);
                    },
                    down: () => {
                        //this._gameLogic.playerShoot(this.$model.playerId);
                    },
                },
            },
        };
    }

    protected onInitialize(): void {
        this.visible = this.$model.visible;

        this.$childControllers.get('Joystick').visible =
            this.$model.showGamePad;
        this.$childControllers.get('Buttons').visible = this.$model.showGamePad;
        this.$childControllers.get('CloseButton').visible = false;
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.y = height / scale / 2 - 160;
        this.x = 0;
    }
}
